import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';

const API = process.env.REACT_APP_BACKEND_URL;

export default function CallbackPage() {
  const { t } = useLanguage();
  const { isLoading, isAuthenticated, error } = useAuth0();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    const provider = searchParams.get('provider');
    const code = searchParams.get('code');

    if (provider === 'facebook' && code) {
      handleFacebookCallback(code);
      return;
    }

    if (!isLoading && isAuthenticated) navigate('/');
    if (!isLoading && error) navigate('/');
  }, [isLoading, isAuthenticated, error, navigate, searchParams]);

  const handleFacebookCallback = async (code) => {
    try {
      setStatus('processing');
      const res = await axios.post(`${API}/api/auth/facebook/callback`, {
        code,
        origin: window.location.origin,
      });
      if (res.data?.token) {
        localStorage.setItem('ct_token', res.data.token);
        localStorage.setItem('ct_user', JSON.stringify(res.data.user));
        window.dispatchEvent(new Event('ct_auth_change'));
        setStatus('success');
        navigate('/');
      }
    } catch (err) {
      setStatus('error');
      setTimeout(() => navigate('/'), 3000);
    }
  };

  return (
    <div className="min-h-screen bg-cream dark:bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-navy mx-auto mb-4" />
        <p className="text-navy dark:text-white font-medium">
          {status === 'error' ? 'Greška pri prijavi. Preusmjeravanje...' : 'Prijavljivanje...'}
        </p>
        {error && <p className="text-red-500 mt-2 text-sm">{error.message}</p>}
      </div>
    </div>
  );
}
